/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_SeatsInputs */

const en_mk_mx_seats = /** @type {(inputs: Mk_Mx_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team members`)
};

const id_mk_mx_seats = /** @type {(inputs: Mk_Mx_SeatsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota tim`)
};

/**
* | output |
* | --- |
* | "Team members" |
*
* @param {Mk_Mx_SeatsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_seats = /** @type {((inputs?: Mk_Mx_SeatsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_SeatsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_seats(inputs)
	return en_mk_mx_seats(inputs)
});